import React, { useState } from "react";

import PackageDetailSection from "./packageDetailSection";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import MobileViewContainer from "../../Components/MobileViewContainer";
import { ChevronLeft } from "lucide-react";
import StepProgressBar from "@/Components/Common/StepProgressBar";

function PackageItemPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [detailProgressPercent, setDetailProgressPercent] = useState(50);
  const [headerTitle, setHeaderTitle] = useState("예약 상세");
  if (!id) return null;
  const selectedDate = searchParams.get("date");
  const isOptionStep = searchParams.get("step") === "options";
  const routeState = location.state || {};

  const handleBack = () => {
    if (isOptionStep) {
      const nextSearchParams = new URLSearchParams(searchParams);
      nextSearchParams.delete("step");
      navigate({
        pathname: location.pathname,
        search: nextSearchParams.toString() ? `?${nextSearchParams.toString()}` : "",
      });
      return;
    }

    navigate(selectedDate ? `/package?date=${selectedDate}` : "/package");
  };

  return (
    <MobileViewContainer>
      <div className="fixed top-0 left-1/2 z-50 w-full max-w-[640px] -translate-x-1/2 border-b border-gray-200/70 bg-white/85 px-4 pb-3 pt-[14px] backdrop-blur-md">
        <div className="grid h-10 grid-cols-[40px_1fr_40px] items-center">
          <button
            type="button"
            onClick={handleBack}
            className="inline-flex h-10 w-10 cursor-pointer items-center justify-center text-gray-700 transition-transform duration-150 hover:text-gray-900 active:scale-[0.96]"
            aria-label="뒤로가기"
          >
            <ChevronLeft size={22} strokeWidth={2.2} />
          </button>
          <div className="text-center">
            <h1 className="text-lg font-bold leading-tight text-gray-900 font-[Gmarket-B]">{headerTitle}</h1>
          </div>
          <div aria-hidden="true" />
        </div>
        <StepProgressBar progressPercent={detailProgressPercent} className="mt-3" />
      </div>

      <div className="pt-[116px]">
        <PackageDetailSection
          id={id}
          initialProduct={routeState.product}
          initialSelectedSpotId={routeState.selectedSpotId}
          onProgressChange={setDetailProgressPercent}
          onHeaderTitleChange={setHeaderTitle}
        />
      </div>

    </MobileViewContainer>
  );
}

export default PackageItemPage;
